import { render } from "./movimientoinventarios.vue?vue&type=template&id=683448f0&scoped=true"
import script from "./movimientoinventarios.vue?vue&type=script&lang=js"
export * from "./movimientoinventarios.vue?vue&type=script&lang=js"

import "./movimientoinventarios.vue?vue&type=style&index=0&id=683448f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683448f0"]])

export default __exports__